export const STORAGE_KEY = 'trade_planner_data';

export const loadData = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : { watchlists: [], daily: {} };
  } catch (error) {
    console.error("Error loading data", error);
    return { watchlists: [], daily: {} };
  }
};

export const saveData = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error saving data", error);
  }
};

export const getDefaultDailyData = () => ({
  overnightIndices: [
    { id: '1', name: 'S&P 500 Futures', close: '', change: '', pctChange: '', notes: '' },
    { id: '2', name: 'Nasdaq Futures', close: '', change: '', pctChange: '', notes: '' },
    { id: '3', name: 'Dow Futures', close: '', change: '', pctChange: '', notes: '' },
    { id: '4', name: 'DAX', close: '', change: '', pctChange: '', notes: '' },
    { id: '5', name: 'FTSE 100', close: '', change: '', pctChange: '', notes: '' },
    { id: '6', name: 'Nikkei 225', close: '', change: '', pctChange: '', notes: '' },
    { id: '7', name: 'Hang Seng', close: '', change: '', pctChange: '', notes: '' },
    { id: '8', name: 'VIX', close: '', change: '', pctChange: '', notes: '' },
    { id: '9', name: 'US 10Y Yield', close: '', change: '', pctChange: '', notes: '' },
    { id: '10', name: 'AUD/USD', close: '', change: '', pctChange: '', notes: '' },
    { id: '11', name: 'Gold', close: '', change: '', pctChange: '', notes: '' },
    { id: '12', name: 'Crude Oil', close: '', change: '', pctChange: '', notes: '' },
  ],
  dailyNotes: '',
  // Updated to support multiple items and carry-over state
  inFocusItems: [] 
});